class AdpDropdownTabsController {
  constructor() {
    this.name = 'adpDropdownTabs';
  }

  openTab (event, tab) {
    event.preventDefault();
    event.stopPropagation();

    if (tab.open && this.visible) {
      this.tabs.forEach(t => t.open = false);
      this.visible = tab.open;
    
    } else {
      this.tabs.forEach(t => t.open = false);
      tab.open = !tab.open;
      this.visible = tab.open;
    }

    if(tab.open) {
      this.onOpen();
    }
    else {
      this.onClose();
    }

    this.item = tab.content;
  } 
  
  hide(event) {
    event.preventDefault();
    event.stopPropagation();

    this.tabs.forEach(t => t.open = false);
    this.onClose();
    this.visible = false;
  }
}

export default AdpDropdownTabsController;





// WEBPACK FOOTER //
// ./src/app/components/adpDropdownTabs/adpDropdownTabs.controller.js